import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Taux API Cartes cadeaux")
], -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import Button from "primevue/button";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import { ref, onMounted } from 'vue';
import moment from 'moment/moment';
import { IJackpot } from "@/models/product/jackpot/IJackpot";
import { fetchJackpot } from "@/_services/jackpot/jackpot";

const defaultRowsPerPage = 30;

export default /*#__PURE__*/_defineComponent({
  __name: 'PageJackpot',
  setup(__props) {

const jackpotStartDate = ref<string>('');
const jackpotEndDate = ref<string>('');
const oglobaStartDate = ref<string>('');
const oglobaEndDate = ref<string>('');
const jackpot = Array<IJackpot>();
const tableData = ref<Array<IJackpot>>(jackpot);
const isLoading = ref<boolean>(true);
const rows = ref<number>(30);
const rowsPerPageOptions = [10, defaultRowsPerPage, 100, 200];
const page = ref<number>(1);
const currentPage = ref<number>(0);
const totalRecords = ref<number>(0);
const brand = ref<string>("");
const supplier = ref<string>("");
const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
onMounted(async () => {
    await populateDatatable();
});

const onFilterDt = () => {
    rows.value = 30;
    page.value = 1;
    populateDatatable();
};

const onClearInputFilter = () => {
    if (brand.value === "") {
        rows.value = 30;
        page.value = 1;
        populateDatatable();
    }
};

async function populateDatatable() {
    const params = {
        brand: brand.value,
        supplier: supplier.value
    };

    const [loadingDt, totalRecordsDt,tableDataDt] = await fetchJackpot(rows.value, page.value, params);
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;
}

function calculateFirstDayOfMonth() {
    return moment().startOf('month').format('YYYY-MM-DD');
}

function getTodaysDate() {
    return moment().format('YYYY-MM-DD');
}

function displayOglobaRate(value: any) {
    return value == 'NULL' || !value ? '0%' : value + '%';
}

onMounted(() => {
    jackpotStartDate.value = calculateFirstDayOfMonth();
    jackpotEndDate.value = getTodaysDate();
    oglobaStartDate.value = calculateFirstDayOfMonth();
    oglobaEndDate.value = getTodaysDate();
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        lazy: "",
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        onPage: onPaginate,
        currentPage: currentPage.value,
        totalRecords: totalRecords.value,
        paginator: true
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormKit, {
              type: "select",
              label: "Rechercher par fournisseur",
              modelValue: supplier.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((supplier).value = $event)),
              onChange: onFilterDt,
              options: [
                        {label: '', value: '' },
                        {label: 'API Ogloba', value: '79c5e982-fc65-4345-8aff-39f4226e2b60' }, 
                        {label: 'API BuyBox', value: '858720ea-a85e-4537-a61d-9b7d494cc8d5' },
                        {label: 'API Tillo', value: '8c7a0e96-3299-4b8b-92dc-161675939bcd' },
                    ]
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                class: "border-[#656565] border-solid border-[1px] w-full max-w-[300px] p-4 pl-[30px]",
                modelValue: brand.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((brand).value = $event)),
                modelModifiers: { trim: true },
                placeholder: "Rechercher par marque",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(Column), {
              field: "product_name",
              header: "Nom du produit"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.productName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "brand",
              header: "Marque"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.brand), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "supplier",
              header: "Fournisseur"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.supplierName), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "status",
              header: "Statut"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "reduction_value",
              header: "Réduction"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.reductionValue != null ? slotProps.data.reductionValue + '%' : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "b2b_discount_rate",
              header: "Taux Api"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(displayOglobaRate(slotProps.data.b2bDiscountRate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "jackpot_min_price",
              header: "Valeur minimale"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.minPrice), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "jackpot_max_price",
              header: "Valeur maximale"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.maxPrice), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'editJackpot', params: { uuid: slotProps.data.variantUuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      icon: "pi pi-pencil",
                      title: "Éditer",
                      class: "p-edition ml-2"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "currentPage", "totalRecords"])
    ])
  ], 64))
}
}

})